import RegisterInitialStep from './Steps/RegisterInitialStep';
import RegisterAccountSetupStep from './Steps/RegisterAccountSetupStep';
import RegisterEmploymentBasicsStep from './Steps/RegisterEmploymentBasicsStep';
import RegisterEmploymentDetailsStep from './Steps/RegisterEmploymentDetailsStep';
import RegisterLastStep from './Steps/RegisterLastStep/RegisterLastStep';
import RegisterSuccessStep from './Steps/RegisterSuccessStep';
import RegisterPhoneNumberStep from './Steps/RegisterPhoneNumberStep';
import RegisterSmsCodeStep from './Steps/RegisterSmsCodeStep';

export const steps = [
  {
    stepId: 1,
    Component: RegisterInitialStep,
  },
  {
    stepId: 2,
    Component: RegisterAccountSetupStep,
  },
  {
    stepId: 3,
    Component: RegisterPhoneNumberStep,
  },
  {
    stepId: 4,
    Component: RegisterSmsCodeStep,
  },
  {
    stepId: 5,
    Component: RegisterEmploymentBasicsStep,
  },
  {
    stepId: 6,
    Component: RegisterEmploymentDetailsStep,
  },
  {
    stepId: 7,
    Component: RegisterLastStep,
  },
  {
    stepId: 8,
    Component: RegisterSuccessStep,
  },
];
